import ChecklistForm from "@/components/checklist/checklist-form";
import { useLocalSearchParams } from "expo-router";
import Drawer from "expo-router/drawer";
import { Text, ScrollView, RefreshControl } from "react-native";
import { KeyboardToolbar } from "react-native-keyboard-controller";
import { trpc } from "@/trpc/react";


export default function ChecklistPage() {
  const { id, crewId, query } = useLocalSearchParams();

  const { refetch, isLoading } = trpc.probationChecklist.list.useQuery({
    crew_id: Number(crewId),
    job_date_id: Number(id),
    show_completed: false, // Only show incomplete items
  });

  return (
    <>
      <Drawer.Screen
        options={{
          title: 'Probation Checklist',
        }}
      />
      <ScrollView
        className="flex-1 bg-background"
        refreshControl={
          <RefreshControl refreshing={isLoading} onRefresh={() => refetch()} />
        }
        contentContainerStyle={{
          padding: 16,
          paddingTop: 40,
          gap: 20,
        }}
      >
        {query ? <Text className="text-xl text-foreground font-extrabold tracking-tight self-start">Complete probation checklist for {query}</Text> : null}
        <ChecklistForm
          crewId={Number(crewId)}
          jobDateId={Number(id)}
          crewMemberName={typeof query === 'string' ? query : undefined}
        />
      </ScrollView>
      <KeyboardToolbar />
    </>
  )
}